import script from "./WidgetContentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetContentHeader.vue?vue&type=script&setup=true&lang=js"

import "./WidgetContentHeader.vue?vue&type=style&index=0&id=8f735bac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f735bac"]])

export default __exports__